import { trpc } from '@/main'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { reportQueryOptions, reportSearchDeps } from '@/hooks/use-report'
import { noop } from '@tanstack/react-query'

/**
 * Layout for a selected employee (`/employees/$employeeId/*`). It owns the employeeId-keyed detail its subtree
 * and the chrome above it read, plus the REPORT query, as in the other four sections: on the report leaf that key
 * re-keys the match on every ámbito/source switch, and a leaf at `pendingMs: 0` paints its skeleton the moment
 * its match reloads. The chrome ABOVE this match (the nav-stack screen title, the breadcrumb) can't be handed
 * this context, so it reads it with `useMatch({ from: '/_app/employees/$employeeId' })`.
 */
export const Route = createFileRoute('/_app/employees/$employeeId')({
  loaderDeps: ({ search }) => reportSearchDeps(search),
  context: ({ deps, params }) => ({
    reportQueryOptions: reportQueryOptions(deps, params),
    employeeQueryOptions: trpc.employees.getEmployee.queryOptions(Number(params.employeeId)),
  }),
  loader: ({ context }) => {
    context.queryClient.query(context.employeeQueryOptions).catch(noop)
    if (context.reportQueryOptions) context.queryClient.query(context.reportQueryOptions).catch(noop)
  },
  component: RouteComponent,
  // No pendingComponent: its ABSENCE is what makes this layout's own re-key harmless, since `offerPending` bails
  // at the first non-success match lacking a numeric `pendingMs`. The report leaf owns the skeleton.
})

function RouteComponent() {
  return <Outlet />
}
